function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogo(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 595.28 595.28",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#0D0E10",
    d: "M514.948 88.782l.055 302.659c.011 57.174-29.683 87.134-48.75 105.542-36.43 35.17-88.504 55.691-150.575 55.701-61.808.008-118.919-28.301-143.213-50.434-21.727-19.788-54.871-53.129-54.881-115.436l-.035-175.174 44.078-.008-.1-44.736 44.454.18-.007-43.628 44.501-.366.048 262.683c0 59.827 41.922 68.271 65.738 68.267 23.01-.003 66.198-12.182 66.198-66.738l-.303-298.513h132.792z"
  }), React.createElement("path", {
    fill: "#0D0E10",
    d: "M148.181 168.65l.005 28.513-28.885.003-.005-28.512 28.885-.004zM171.17 42.597h20.077v19.818H171.17z"
  }), React.createElement("path", {
    fill: "#0D0E10",
    d: "M192.154 124.752l.004 28.51-28.884.005-.004-28.511 28.884-.004zm15.565-45.52l.005 28.51 28.885-.005-.005-28.51-28.885.005zm-41.703 5.382l.002 24.752 25.078-.004-.002-24.751-25.078.003zm-44.351 44.273l.005 24.755 25.078-.004-.005-24.755-25.078.004zm-38.764 2.759l.003 19.817 20.08-.003-.004-19.818-20.079.004zm44.257-45.275l.005 19.818 20.08-.003-.005-19.818-20.08.003zm44.01-43.772l.004 19.818 20.077-.003-.004-19.818-20.077.003zM84.892 89.381l.003 15.452 15.656-.002-.003-15.452-15.656.002zm44.76-44.522l.003 15.45 15.657-.003-.004-15.45-15.656.003zm-42.263 2.008l.002 10.077 10.211-.002-.001-10.076-10.212.001z"
  }));
}

SvgLogo.clsName = 'icon-www__logo';
SvgLogo.remarkName = 'unknown';
export default SvgLogo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Logo.js
// module id = 2379
// module chunks = 17 18